import { BrowserRouter, Route, Routes } from "react-router";
import { CreatePage } from "./pages/create";
import { GradePage } from "./pages/grade";
import { HomePage } from "./pages/home";
import { WorksheetPage } from "./pages/worksheet";
import { ROUTES } from "./routes";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.create} element={<CreatePage />} />
        <Route path={ROUTES.grade} element={<GradePage />} />
        <Route path={ROUTES.worksheet} element={<WorksheetPage />} />
      </Routes>
    </BrowserRouter>
  );
}
